import React, {useContext, useState} from 'react'
import ListCustomersForm from './form/ListCustomersForm'
import {ListCustomersContext} from "./../context/ListCustomersContext";
import Filter from "../../../statics/assets/icons/filter.svg";
import ListCustomersFilters from "./filters/ListCustomersFilters";
import FilterInput from "../../customers/components/filters/FilterInput";
import {Pagination} from "antd";
import ListCustomerTable from "./table/ListCustomerTable";
import {getLocalData, setLocalData} from "../../../services/StorageServices";

function ListCustomerPage() {
    const ListCustomersPageContext = useContext(ListCustomersContext)
    const {
        listCustomers,
        total,
        page,
        limit,
        loading,
        error,
        filters,
        setFiltersState,
        setLimit,
        setPage
    } = ListCustomersPageContext
    const {customerListCode, showFiltersLocal = false} = filters
    const [showFilters, toggleFilters] = useState(showFiltersLocal)

    const _toggleShowFilter = () => {
        const listCustomersFilters = getLocalData('listCustomersFilters') || {}
        setLocalData('listCustomersFilters', {...listCustomersFilters, showFiltersLocal: !showFilters})
        toggleFilters(!showFilters)
    }

    const _handleChangeInput = (e) => {
        const {name, value} = e.target
        setFiltersState({
            ...filters,
            [name]: value
        })
    }

    const _onChangePagination = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    return <div className='ListCustomerPage PageDefault position-relative'>
        <div className="PageHeading">
            <h1 className="PageTitle">Danh sách khách hàng</h1>
            <div className="d-flex align-items-center PageFilterTop">
                <div className={`Filter mr-3 ${showFilters && 'filtersOpen'}`}>
                    <label onClick={_toggleShowFilter}><Filter width={20} height={20}/>Bộ lọc</label>
                </div>
                <FilterInput
                    label=""
                    name="customerListCode"
                    placeholder="Mã danh sách"
                    value={customerListCode}
                    onChangeInput={_handleChangeInput}
                />
                <ListCustomersForm/>
            </div>
        </div>
        {showFilters && <ListCustomersFilters filters={filters} setFiltersState={setFiltersState}/>}
        <div className="PageTable">
            <ListCustomerTable loading={loading} error={error} listCustomers={listCustomers}/>
            <div className="PagePagination">
                <Pagination
                    className="PaginationCustom"
                    total={total}
                    pageSize={limit}
                    current={page}
                    onChange={_onChangePagination}
                />
            </div>
        </div>
    </div>
}

export default ListCustomerPage
